import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { IAppState } from '../../redux/reducers';



export const PublicRoute = ({ children, token, ...rest }) => {
    let auth = useSelector((state:IAppState) => state?.auth)
    const isAuthenticated = auth && auth?.token || token;
    return (<Route {...rest} render={props => (
        token
            ? <Redirect to={{ pathname: '/jobs', state: { from: props.location } }} />
            : (children)
    )} />)
    // return (<Route {...rest} render={props => (
    //     (children)
    // )} />)


}
export default PublicRoute;
